import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { X, Cookie } from 'lucide-react';

const COOKIE_CONSENT_KEY = 'cookie_consent_accepted';

export function CookieConsent() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!consent) {
      // Показываем баннер через небольшую задержку для лучшего UX
      const timer = setTimeout(() => setIsVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'true');
    setIsVisible(false);
  };

  const handleDecline = () => {
    // При отказе сохраняем выбор, но не устанавливаем аналитические cookies
    localStorage.setItem(COOKIE_CONSENT_KEY, 'essential_only');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 md:p-6 animate-slide-up">
      <div className="container mx-auto">
        <div className="bg-white rounded-2xl shadow-2xl border border-gray-200 p-6 md:flex md:items-center md:justify-between gap-6">
          <div className="flex items-start gap-4 mb-4 md:mb-0">
            <div className="w-12 h-12 bg-[#FFCC00] rounded-xl flex items-center justify-center flex-shrink-0">
              <Cookie className="w-6 h-6 text-black" />
            </div>
            <div className="flex-1">
              <h3 className="font-semibold text-lg mb-1">Мы используем cookies</h3>
              <p className="text-gray-600 text-sm">
                Для улучшения работы сайта и персонализации мы используем файлы cookie. 
                Продолжая использовать сайт, вы соглашаетесь с{' '}
                <Link to="/privacy" className="text-[#FFCC00] hover:underline">
                  Политикой конфиденциальности
                </Link>.
              </p>
            </div>
          </div>
          
          <div className="flex flex-col sm:flex-row gap-3 flex-shrink-0">
            <button
              onClick={handleDecline}
              className="px-6 py-3 text-gray-700 bg-gray-100 rounded-xl font-medium hover:bg-gray-200 transition-colors"
            >
              Только необходимые
            </button>
            <button
              onClick={handleAccept}
              className="px-6 py-3 bg-[#FFCC00] text-black rounded-xl font-semibold hover:bg-[#E6B800] transition-colors"
            >
              Принять все
            </button>
          </div>
          
          <button
            onClick={handleDecline}
            className="absolute top-4 right-4 md:hidden text-gray-400 hover:text-gray-600"
            aria-label="Закрыть"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
      </div>
      
      <style>{`
        @keyframes slide-up {
          from {
            transform: translateY(100%);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }
        .animate-slide-up {
          animation: slide-up 0.3s ease-out;
        }
      `}</style>
    </div>
  );
}
